/**
 * Type guard narrowing `unknown` to a non-null object, so callers can index it
 * without a type error. Arrays pass too (they are objects); a caller that must
 * exclude them should check `Array.isArray` first.
 */
export function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null;
}

// Arrays are objects too; a payload or global read as a record must not be one.
export function asRecord(value: unknown): Record<string, unknown> | undefined {
  return isRecord(value) && !Array.isArray(value) ? value : undefined;
}
